export default __webpack_public_path__ + "static/media/p5.b84bada8.png";